<template>
  <IndexBlok :id="1"></IndexBlok>
</template>

<script>

    import IndexBlok from "../../components/Doc/IndexBlok";
    export default {
        components: {IndexBlok},
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Yonetim/index.vue